"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlobalConfig = void 0;
var lodash_1 = __importDefault(require("lodash"));
var url_1 = require("./url");
var GlobalConfig = /** @class */ (function () {
    function GlobalConfig(params) {
        this.params = params;
    }
    Object.defineProperty(GlobalConfig.prototype, "CookieDomain", {
        get: function () {
            return url_1.currentCookieDomain();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GlobalConfig.prototype, "Region", {
        get: function () {
            return this.params.region;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GlobalConfig.prototype, "IsCN", {
        get: function () {
            return lodash_1.default.toLower(this.Region) === 'cn';
        },
        enumerable: false,
        configurable: true
    });
    return GlobalConfig;
}());
exports.GlobalConfig = GlobalConfig;
//# sourceMappingURL=global_config.js.map